import axios from '@/plugins/axios_and_toast.js'

async function getHTML(id) {
  const url = `/letter-web-version/${id}`
  const result = await axios.get(url)
  return result.data
}

export { getHTML }
